/* Atelier Elemental - auto-add the free 2ml Mystery Decant.
 * Built 2026-08-22 to replace the "add it + type code AE-SAMPLE" flow with a
 * hands-off gift: when the cart's non-gift subtotal reaches the threshold and
 * the shopper is eligible (first order), the gift is added and the AE-SAMPLE
 * discount is applied silently so it rings up at $0. If the shopper is NOT
 * eligible (returning customer -> code rejected) the gift is removed again so
 * no one is ever charged for it. Auto-removes if the cart drops below the
 * threshold. Respects a manual removal (won't re-add in the same session).
 *
 * Config comes from window.__AE_GIFT (set inline by footer-group.json):
 *   { variantId, threshold (cents), code, customerOrders }
 * Verified 2026-08-22: /discount/AE-SAMPLE applied via fetch makes the gift
 * line final_line_price === 0 in /cart.js (line_level_discount_allocations).
 */
(function () {
  var C = window.__AE_GIFT || {};
  var VARIANT = Number(C.variantId);
  var THRESHOLD = Number(C.threshold) || 2500;
  var CODE = C.code || '';   // 2026-09-01: the gift variant is priced $0, no code needed
  var ORDERS = Number(C.customerOrders) || 0;
  var LOGGED_IN = !!Number(C.loggedIn);   // 2026-09-01 (Sean): the free vial is for logged-in customers only
  if (!VARIANT) return;

  var SS = window.sessionStorage;
  var busy = false, scheduled = false, lastGiftPresent = false;

  function getJSON(u, o) {
    return fetch(u, Object.assign({ headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } }, o || {})).then(function (r) { return r.json(); });
  }
  function cart() { return getJSON('/cart.js'); }
  function giftIn(c) { return c.items.filter(function (i) { return i.variant_id === VARIANT; })[0]; }
  function nonGiftSubtotal(c) {
    // cart.total_price includes both line discounts AND order-level discounts.
    // final_line_price alone does not include cart-level discount allocations.
    var giftTotal = c.items.reduce(function (s, i) { return i.variant_id === VARIANT ? s + i.final_line_price : s; }, 0);
    return Math.max(0, Number(c.total_price) - giftTotal);
  }

  function flag(k, v) { try { if (v === undefined) return SS.getItem('aeGift_' + k) === '1'; if (v) SS.setItem('aeGift_' + k, '1'); else SS.removeItem('aeGift_' + k); } catch (e) { } }

  function applyCode() { if (!CODE) return Promise.resolve(); return fetch('/discount/' + encodeURIComponent(CODE), { redirect: 'follow' }).catch(function () { }); }
  function addGift() { return getJSON('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: [{ id: VARIANT, quantity: 1, properties: { _free_gift: 'true' } }] }) }); }
  // Remove by LINE KEY, not variant id: /cart/change.js by variant id does not
  // reliably remove a line that carries properties (verified 2026-08-22).
  function removeGift(key) { return getJSON('/cart/change.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: 0 }) }); }
  function capGift(key) { return getJSON('/cart/change.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: 1 }) }); }

  function refreshUI() {
    // Best-effort: re-render cart sections via the Section Rendering API, then
    // fire the events Dawn/Horizon-style themes listen for.
    var ids = [];
    document.querySelectorAll('[id^="shopify-section-"]').forEach(function (el) {
      if (/cart|drawer|bubble/i.test(el.id)) ids.push(el.id.replace('shopify-section-', ''));
    });
    var done = function () {
      ['cart:refresh', 'cart:updated', 'cart-drawer:refresh'].forEach(function (n) {
        document.dispatchEvent(new CustomEvent(n, { bubbles: true }));
      });
    };
    if (!ids.length) return done();
    fetch('/?sections=' + ids.join(',')).then(function (r) { return r.json(); }).then(function (data) {
      ids.forEach(function (id) {
        var host = document.getElementById('shopify-section-' + id);
        if (host && data[id]) {
          var doc = new DOMParser().parseFromString(data[id], 'text/html');
          var fresh = doc.getElementById('shopify-section-' + id);
          if (fresh) host.innerHTML = fresh.innerHTML;
        }
      });
      done();
    }).catch(done);
  }

  function evaluate() {
    if (busy) { scheduled = true; return; }
    busy = true;
    cart().then(function (c) {
      var g = giftIn(c), sub = nonGiftSubtotal(c), eligible = LOGGED_IN && ORDERS === 0;

      if (sub < THRESHOLD) { flag('removed', false); flag('ineligible', false); }

      // Detect a manual removal: gift was here last pass, gone now, and we're
      // still above threshold (so the cart didn't drop it) -> shopper removed it.
      if (lastGiftPresent && !g && sub >= THRESHOLD && eligible) flag('removed', true);
      lastGiftPresent = !!g;

      var changed = false, chain = Promise.resolve();

      if (g) {
        if (sub < THRESHOLD || !eligible) {       // below threshold, or not a logged-in first-order customer -> pull the gift
          chain = removeGift(g.key).then(function () { changed = true; });
        } else if (g.quantity > 1) {                // one free vial, never more (the line is $0 now)
          chain = capGift(g.key).then(function () { changed = true; });
        } else if (g.final_line_price > 0) {      // present but NOT free -> not eligible -> pull it
          chain = applyCode().then(function () { return cart(); }).then(function (c2) {
            var g2 = giftIn(c2);
            if (g2 && g2.final_line_price > 0) { flag('ineligible', true); return removeGift(g2.key).then(function () { changed = true; }); }
          });
        }
      } else if (sub >= THRESHOLD && eligible && !flag('removed') && !flag('ineligible')) {
        chain = applyCode().then(addGift).then(function () { return cart(); }).then(function (c2) {
          var g2 = giftIn(c2);
          if (!g2) return;
          if (g2.final_line_price > 0) { flag('ineligible', true); return removeGift(g2.key); } // safety: never charge
          changed = true; lastGiftPresent = true;
        });
      }

      chain.then(function () {
        busy = false;
        if (changed) refreshUI();
        if (scheduled) { scheduled = false; setTimeout(evaluate, 40); }
      }).catch(function () { busy = false; });
    }).catch(function () { busy = false; });
  }

  function schedule() { clearTimeout(schedule._t); schedule._t = setTimeout(evaluate, 120); }

  // Re-evaluate after any cart mutation the theme performs.
  var _fetch = window.fetch;
  window.fetch = function () {
    var args = arguments, url = (args[0] && args[0].url) || args[0];
    var p = _fetch.apply(this, args);
    try { if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) p.then(schedule, function () { }); } catch (e) { }
    return p;
  };
  var _open = window.XMLHttpRequest && XMLHttpRequest.prototype.open;
  if (_open) {
    XMLHttpRequest.prototype.open = function (m, u) {
      try { if (typeof u === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(u)) this.addEventListener('load', schedule); } catch (e) { }
      return _open.apply(this, arguments);
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
  window.addEventListener('pageshow', schedule);
})();

